import {logout} from './auth';

export default function({networkError}, client) {
  if (networkError && networkError.statusCode === 401) {
    logout(client);
    return false;
  }
  return true;
}
